import { Modal, ModalTabs, PDFRenderer } from "components";
import config from "config";
import _ from "lodash";
import { useTreaty, useTreatyReinsurer } from "hooks/data/use-treaties";
import { classNames, useUrlState } from "utils";
import { useEffect, useMemo, useState } from "react";
import {
  useAppLocation,
  useAppSearch,
  useCurrentUser,
} from "_graphql/cache/auth";

const modalTabs = [
  { name: "Closing Note", href: "CLOSING_NOTE" },
  { name: "NIC Schedule", href: "NIC_SCHEDULE" },
];

export default function ViewNonProportionalTreatyClosingContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const currentUser = useCurrentUser();
  const searchParams = useAppSearch();
  const [, setOrderTab] = useUrlState("uuid");
  const [modalTab, setModalTab] = useState("CLOSING_NOTE");

  const { params } = useAppLocation();
  // useMatch<LocationGenerics>();
  // const { reInsurer, loading: fetchingLoading } = useReInsurer(searchParams?.id || "");
  const { participant, loading: fetchingParticipant } = useTreatyReinsurer({
    participationId: searchParams?.id || "",
  });
  const { treaty, loading } = useTreaty({
    treatyId: params?.treaty,
  });

  useEffect(() => {
    if (treaty) {
      const layerLimit: any[] = JSON.parse(treaty?.layer_limit || "[]");
      setOrderTab(_.first(layerLimit)?.uuid || "");
    }
  }, [treaty, treaty?.layer_limit]);

  const isAdjustmentCreated = useMemo(() => {
    return treaty?.treaty_np_detail?.adjustment_created;
  }, [treaty?.treaty_np_detail]);
  const layer = useMemo(
    () =>
      JSON.parse(treaty?.layer_limit || "[]")?.at(
        Number(searchParams?.layer) - 1
      ),
    [searchParams?.layer, treaty?.layer_limit]
  );

  const urls = {
    CLOSING_NOTE: `${config.asset.uri}treaty_np_credit_note/${btoa(
      JSON.stringify({
        limit: layer?.limit,
        layer: participant?.layer_number,
        m_and_d_premium: layer?.m_and_d_premium,
        installment_type: layer?.installment_type,
        participant_id: participant?.treaty_participation_id,
        uuid: layer?.uuid,
        total_participation_percentage:
          participant?.treaty_participation_percentage,
      })
    )}`,

    NIC_SCHEDULE: `${config.asset.uri}treaty_nic_schedule/${btoa(
      JSON.stringify({
        treaty_id: treaty?.treaty_id,
        insurer_id: treaty?.insurer?.insurer_id,
        from: treaty?.treaty_deduction?.treaty_period_from,
        to: treaty?.treaty_deduction?.treaty_period_to,
        period: layer?.installment_type,
        currency: treaty?.currency,
        type: treaty?.treaty_program?.treaty_type,
      })
    )}`,
    ADJUSTMENT_STATEMENT: `${config.asset.uri}treaty_adjustment_statement/${btoa(
      JSON.stringify({
        treaty_participation_id: searchParams?.id,
        treaty_id: treaty?.treaty_id,
        emp_id: currentUser?.employee?.employee_id,
      })
    )}`,
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      hidePadding
      loading={loading || fetchingParticipant}
      title={"Preview Documents"}
      description="Preview the documents related to this treaty"
    >
      <ModalTabs
        tabs={[
          ...modalTabs,
          ...(isAdjustmentCreated
            ? [{ name: "Adjustment Statement", href: "ADJUSTMENT_STATEMENT" }]
            : []),
        ]}
        setOrderStatus={setModalTab}
        orderStatus={modalTab}
      />
      {/* {JSON.stringify(layer, null, 2)} */}
      {searchParams?.layer && (
        <div className="p-3">
          <PDFRenderer url={_.get(urls, modalTab, "")} />
        </div>
      )}
    </Modal>
  );
}
